import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
import Modal from "react-modal";

const HubStockInfoForm = (props) => {
  const frmRef = useRef({});
  const productRef = useRef({});
  const [productData, setProductData] = useState([]);
  const [productId, setProductId] = useState(0);
  const [productDetails, setProductDetails] = useState([]);
  const [unitId, setunitId] = useState();
  const [loading, setLoading] = useState(false);

  const [employeeId, setEmployeeId] = useState(null);
  const [employeelist, setEmployeelist] = useState(null);

  const [filteredEmployees, setFilteredEmployees] = useState([]);

  const [vendorData, setVendorData] = useState([]);
  const [selectedVendorId, setSelectedVendorId] = useState();

  const [inputTemplateDetail, setInputTemplateDetail] = useState([]);
  const [farmerInputTemplateId, setFarmerInputTemplateId] = useState("");

  const [farmerData, setFarmerData] = useState();
  const [selectedFarmerId, setSelectedFarmerId] = useState();
  const [areaInHa, setAreaInHa] = useState(1);
  const [qtyPerHa, setQtyPerHa] = useState();
  const [availableAmount, setavailableAmount] = useState();
  const [pricePerUnit, setPricePerUnit] = useState();

  const [warehosuedata, setWarehosuedata] = useState([]);
  const [warehouseId, setWarehouseId] = useState(0);

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  var dateString =
    d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const [editingRow, setEditingRow] = useState(null);
  const [editData, setEditData] = useState({});

  const handleEditClick = (index, item) => {
    // setEditingRow(index);
    // setEditData({ ...item });
  };

  const handleInputChange = (field, value) => {
    setEditData((prevData) => ({ ...prevData, [field]: value }));
  };

  const handleSaveClick = (index) => {
    setProductDetails((prevDetails) =>
      prevDetails.map((item, i) => (i === index ? editData : item))
    );
    setEditingRow(null);
    setEditData({});
  };

  const { sendRequest: getWarehouseData } = useHttp();

  const getWarehouseDetail = () => {
    getWarehouseData(
      {
        url: `/api/warehouses/?orgId=${localStorage.getItem(
          "orgId"
        )}&&storeTypeId=2&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          //console.log("warehouse data", res);
          setWarehosuedata(res);
        }
      }
    );
  };

  useEffect(() => {
    getWarehouseDetail();
  }, [getWarehouseData]);

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Agri Promoter&orgId=${localStorage.getItem(
          "orgId"
        )}`,
        //url: `/api/getEmps/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("emp", data.output);
        setEmployeelist(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getFarmerInputTemplate } = useHttp();

  const getFarmerInputTemplateData = () => {
    getFarmerInputTemplate(
      {
        url: `/api/farmerInputTemplateWithStock/?orgId=${localStorage.getItem(
          "orgId"
        )}&warehouseId=${warehouseId}`,
      },
      (res) => {
        // console.log("farmerdata", res);
        if (res) {
          setFarmerData(res);
        }
      }
    );
  };

  useEffect(() => {
    getFarmerInputTemplateData();
  }, [getFarmerInputTemplate]);

  const { sendRequest: getVendor } = useHttp();

  const getVendorDetail = () => {
    getVendor(
      {
        url: `/api/addVendor/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        // console.log("Vendor", res);
        if (res) {
          setVendorData(res);
        }
      }
    );
  };

  useEffect(() => {
    getVendorDetail();
  }, [getVendor]);

  const { sendRequest: getproduct } = useHttp();

  const getProductDetail = () => {
    getproduct(
      {
        url: `/api/fillProductForAgriPromoterAutoComplete/?orgId=${localStorage.getItem(
          "orgId"
        )}&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          // console.log("product", res);
          setProductData(res);
        }
      }
    );
  };

  useEffect(() => {
    getProductDetail();
  }, [getproduct]);

  const { sendRequest: getAvailableStock } = useHttp();

  const loadStockData = (id) => {
    productRef.current.productType.value = "";

    var itemlist = productData?.filter((item) => item.productId == id || 0);
    var selectedItem = itemlist[0];

    productRef.current.productType.value = selectedItem?.productTypeName || "";
    const data = {
      warehouseId: warehouseId,
      productId: id,
    };

    getAvailableStock(
      {
        url: "/api/getAvailableStock/",
        method: "POST",
        body: data,
      },
      (myres) => {
     //   console.log("getAvailableStock", res);
        var res=myres.data
        productRef.current.availableQty.value = res.availableQty;
        productRef.current.unitName.value = res.unitName;
        productRef.current.pricePerUnit.value = res.pricePerUnit;
        productRef.current.qtyPerHa.value = res.qtyPerHa;
      
        setavailableAmount(res.availableAmount ?? 0);
        setPricePerUnit(res.pricePerUnit ?? 0);
        setunitId(res.unitId);

        CalculateGoodsQty(areaInHa, res.qtyPerHa, res.pricePerUnit);
      }
    );
  };

  const CalculateGoodsQty = (_areaInHa, _qtyPerHa, _pricePerUnit) => {
    const area = _areaInHa || areaInHa;
    const qtyPerHa = _qtyPerHa || productRef.current.qtyPerHa?.value;
    const price = _pricePerUnit || productRef.current.pricePerUnit?.value;

    if (!area || !qtyPerHa || !price) return;

    const totalQtyRequired = parseFloat(area) * parseFloat(qtyPerHa);
    const totalAmountRequired =
      parseFloat(totalQtyRequired) * parseFloat(price);
    productRef.current.quantity.value = totalQtyRequired.toFixed(2);
    productRef.current.goodsAmt.value = totalAmountRequired.toFixed(2);
  };

  useEffect(() => {
    CalculateGoodsQty(areaInHa, qtyPerHa, pricePerUnit);
  }, [areaInHa, qtyPerHa, pricePerUnit]);

  const submitProduct = (e) => {
    e.preventDefault();
    // console.log("productId", productId);
    if (productId === 0) {
      toast.error("Please select the product name");
      return;
    }

    var itemlist = productData.filter((item) => item.productId == productId);
    var selectedItem = itemlist[0];

    var productId1 = productId;
    var itemId = selectedItem.itemId;
    var productName = selectedItem.productName;
    // var productSubType = productRef.current.productSubType.value;
    var productType = productRef.current.productType.value;
    var availableQuantity = productRef.current.availableQty.value;
    var unit = productRef.current.unitName.value;
    var _unitId = unitId;
    var availableAmt = availableAmount;
    // var availableAmount1 = availableAmount;
    var _pricePerUnit = pricePerUnit;
    var quantity = productRef.current.quantity.value;
    const _qtyPerHa = productRef.current.qtyPerHa.value;
    var totalQuantity = (
      parseFloat(availableQuantity) + parseFloat(quantity)
    ).toFixed(2);
    var value = (parseFloat(quantity) * parseFloat(_pricePerUnit)).toFixed(2);
    var pdlist = productDetails.filter((item) => item.productId == productId1);

    if (parseFloat(pricePerUnit) == "0") {
      toast.error("Rate/Unit is  required", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    if (parseFloat(_qtyPerHa) == "0") {
      toast.error("Quantity Received is  required", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    if (parseFloat(quantity) === " ") {
      toast.success("Please enter good quantity", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    if (pdlist.length != 0) {
      toast.success("Product already present into the list", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    setProductDetails((x) => [
      ...x,
      {
        srno:
          productDetails.length > 0
            ? productDetails[productDetails.length - 1].srno + 1
            : 1,
        productId: productId1,
        itemId: itemId,
        productName: productName,
        // productType: productSubType,
        productType: productType,
        currentQuantity: availableQuantity,
        currentAmount: availableAmt,
        quantity: parseFloat(quantity),
        unit: unit,
        unitId: _unitId,
        totalQuantity: parseFloat(totalQuantity).toFixed(2),
        pricePerUnit: _pricePerUnit,
        value: value,
        qtyPerHa: _qtyPerHa,

        productCost: 0,

        status: 1,
        createdBy: parseInt(localStorage.getItem("id")),
        orgId: localStorage.getItem("orgId"),
      },
    ]);

    setProductId(0);

    productRef.current.productType.value = "";
    productRef.current.unitName.value = "";
    productRef.current.availableQty.value = "";
    productRef.current.pricePerUnit.value = "";
    productRef.current.qtyPerHa.value = "";

    productRef.current.quantity.value = "";
    productRef.current.goodsAmt.value = "";
    setunitId();
    setavailableAmount();
    setPricePerUnit();
    setQtyPerHa();
    // productRef.current.itemQuantity.value = "0";
    console.log("productDetails", productDetails);
  };
  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };

  const handleValidateQuantityChange = (event) => {
    var validator = new RegExp("^[0-9.]*$");

    var qtyvalid = validator.test(event.target.value);
    //console.log("handleValidateQuantityChange");
    //console.log(qtyvalid);
    if (qtyvalid) {
      // var quantity = parseFloat(event.target.value);
      // var totalquantity = parseFloat(
      //   productRef.current.availableQuantity.value
      // );
      // if (quantity > totalquantity) {
      //   event.target.value = 0;
      //   toast.success("Please enter quanitty less than total quantity", {
      //     position: toast.POSITION.TOP_RIGHT,
      //   });
      //}
    } else {
      event.target.value = 0;
    }
  };

  const recalculateTable = (newAreaValue) => {
    const area = parseFloat(newAreaValue) || 0;

    // Recalculate product details with the new area
    const updatedProductDetails = productDetails.map((item) => {
      const quantity = parseFloat(item.qtyPerHa) * area;
      const value = quantity * parseFloat(item.pricePerUnit);

      return {
        ...item,
        quantity: quantity.toFixed(2),
        value: value.toFixed(2),
        totalQuantity: (parseFloat(item.currentQuantity) + quantity).toFixed(2),
      };
    });

    setProductDetails(updatedProductDetails);
  };

  const { sendRequest: getFITDetail } = useHttp();

  const FillFarmerInputTemplateDetail = (Id, areaValue) => {
    const areaInHa =
      areaValue || parseFloat(frmRef.current.areaInHa.value) || 0;
    // console.log("Template detail", Id);

    var farmerInputTemplateId = Id;
    getFITDetail(
      {
        url: `/api/farmerInputTemplateWithStock/?orgId=${localStorage.getItem(
          "orgId"
        )}&farmerInputTemplateId=${farmerInputTemplateId}&warehouseId=${warehouseId}`,
      },
      (res) => {
        // console.log("farmer input tamplate", res);
        if (res) {
          var farmerInputTempDetails = res.farmerInputTempDetails;
          setInputTemplateDetail(farmerInputTempDetails);
          setFarmerInputTemplateId(res.farmerInputTemplateId);

          var areaInHa = parseFloat(frmRef.current.areaInHa.value);
          var newList = [];
          var iCounter = 0;
          farmerInputTempDetails.forEach(function (itemData) {
            // console.log("item", itemData);

            //Build JSON
            iCounter = iCounter + 1;
            newList = newList.concat({
              srno: iCounter,
              productId: itemData.productId,
              itemId: itemData.itemId,
              productName: itemData.productName,
              productSubType: itemData.productSubType,
              productType: itemData.productTypeName,
              currentQuantity: itemData.currentStock,
              unit: itemData.unitAbbreviation,
              unitId: itemData.unitId,
              qtyPerHa: parseFloat(itemData.quantity),
              currentAmount: itemData.currentStockAmount,
              pricePerUnit: itemData.pricePerUnit,
              quantity: parseFloat(itemData.quantity) * areaInHa,
              itemQuantity: parseFloat(itemData.quantity) * areaInHa,
              itemQuantityBal: parseFloat(itemData.quantity) * areaInHa,
              value:
                parseFloat(itemData.quantity) *
                areaInHa *
                parseFloat(itemData.pricePerUnit),
              totalQuantity:
                parseFloat(itemData.currentStock) +
                parseFloat(itemData.quantity) * areaInHa,
              damagedQuantity: 0,
              status: 1,
              createdBy: parseInt(localStorage.getItem("id")),
              orgId: localStorage.getItem("orgId"),
            });
          });
          setProductDetails(newList);
        }
      }
    );
  };

  useEffect(() => {
    FillFarmerInputTemplateDetail(0, areaInHa);
  }, [getFITDetail]);

  const { sendRequest: postProcurementOfficer } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    setLoading(true);

    // if (productId === 0) {
    //   toast.error("Please select the product");
    //   return;
    // }
    if (productDetails.length === 0) {
      toast.error("Please add the product", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    const data = {
      openingStockDate: moment(frmRef.current.date.value).format("DD/MM/YYYY"),

      warehouseId: warehouseId,
      vendorId: selectedVendorId,
      areaInHa: 1,
      status: 1,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      serviceId: 20,
      createdDate: dateString,
      productDetail: productDetails,
    };
    console.log("data", data);
    if (props.update) {
      data["openingStockId"] = props.update.openingStockId;
    }
    postProcurementOfficer(
      {
        url: "/api/hubDirectStock/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        //console.log(data);
        toast.success(`Hub stock entry ${props.update ? "updated" : "added!"}`);
        props.addForm(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
      }
    );
  };

  useEffect(() => {
    if (props.update) {
      frmRef.current.date.value = moment(props.update.gtProcurementDate).format(
        "YYYY-MM-DD"
      );
      setProductDetails(props.update.productDetail);
    }
  }, [props.update]);

  const handelWarehouseChange = (e) => {
    // console.log(e.target.value);

    const wId = e.target.value || 0;

    setWarehouseId(wId);
    setEmployeeId(0);

    const filteredEmp = employeelist?.filter((itm) => itm.warehouseId == wId);
    console.log(filteredEmp);
    setFilteredEmployees(filteredEmp);
  };

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Add Hub Stock Entry</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"date"}>{"Date "}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"warehouseId"}>{"Warehosue"}</label>

                      <select
                        id="warehouseId"
                        className="form-control"
                        ref={(el) => (frmRef.current["warehouseId"] = el)}
                        value={warehouseId}
                        required
                        onChange={handelWarehouseChange}
                      >
                        <option value="">Select Warehouse</option>
                        {warehosuedata &&
                          warehosuedata.map((x) => (
                            <option key={x.id} warehouse-id={x.id} value={x.id}>
                              {x.name} {}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"emp_id"}>
                        {"Assigned Supervisor Employee"}
                      </label>
                      <select
                        id="emp_id"
                        required
                        className="form-control"
                        ref={(el) => (frmRef.current["assignEmployeeId"] = el)}
                        value={employeeId}
                        onChange={(e) => {
                          setEmployeeId(e.target.value);
                        }}
                      >
                        <option value="">Select</option>
                        {filteredEmployees &&
                          filteredEmployees.map((x) => (
                            <option key={x.empId} value={x.empId}>
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"vendorId"}>{"Vendor"}</label>
                      <select
                        id="vendorId"
                        className="form-control"
                        required
                        ref={(el) => (frmRef.current["selectedVendorId"] = el)}
                        value={selectedVendorId}
                        onChange={(e) => {
                          setSelectedVendorId(e.target.value);
                        }}
                      >
                        <option value="">Select</option>
                        {vendorData &&
                          vendorData.map((x) => (
                            <option key={x.vendorId} value={x.vendorId}>
                              {x.vendorName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row">&nbsp;</div>
                  <div className="row">
                    <h5>Product Detail</h5>
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"productId"}> Product </label>
                      <select
                        id="productId"
                        className="form-control"
                        required
                        ref={(el) => (frmRef.current["productId"] = el)}
                        value={productId}
                        onChange={(e) => {
                          setProductId(e.target.value);
                          loadStockData(e.target.value);
                        }}
                      >
                        <option value="0">Select Product</option>
                        {productData &&
                          productData.map((x) => (
                            <option key={x.productId} value={x.productId}>
                              {x.productName + "(" + x.itemId + ")"}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"productId"}>
                        {" "}
                        Product Sub Type{" "}
                      </label>{" "}
                      <input
                        type={"input"}
                        id={"itemType"}
                        readOnly
                        ref={(el) => (productRef.current["productType"] = el)}
                        className="form-control"
                      />{" "}
                    </div>

                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"unitName"}>Unit</label>
                      <input
                        type={"input"}
                        id={"unitName"}
                        readOnly
                        ref={(el) => (productRef.current["unitName"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"pricePerUnit"}>Rate/Unit</label>
                      <input
                        type={"text"}
                        id={"pricePerUnit"}
                        ref={(el) => (productRef.current["pricePerUnit"] = el)}
                        className="form-control"
                        value={pricePerUnit}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d*\.?\d*$/.test(value)) {
                            setPricePerUnit(value);
                            CalculateGoodsQty(areaInHa, qtyPerHa, value);
                          }
                        }}
                      />
                    </div>
                  </div>
                  <br />
                  <div className="row">
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"qtyPerHa"}>Quantity Received</label>
                      <input
                        type={"text"}
                        id={"qtyPerHa"}
                        ref={(el) => (productRef.current["qtyPerHa"] = el)}
                        className="form-control"
                        value={qtyPerHa}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d*\.?\d*$/.test(value)) {
                            setQtyPerHa(value);
                            CalculateGoodsQty(areaInHa, value, pricePerUnit);
                          }
                        }}
                      />
                    </div>
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"availableQty"}>Current Quantity</label>
                      <input
                        type={"input"}
                        id={"itemType"}
                        readOnly
                        ref={(el) => (productRef.current["availableQty"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"quantity"}>Goods Quantity</label>
                      <input
                        type={"input"}
                        id={"quantity"}
                        // required
                        ref={(el) => (productRef.current["quantity"] = el)}
                        className="form-control"
                        // pattern={decimalPattern}
                        // onChange={(e) => {
                        //   handleValidateQuantityChange(e);
                        // }}
                      />
                    </div>
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"goodsAmt"}>Goods Amount</label>
                      <input
                        type={"input"}
                        id={"goodsAmt"}
                        ref={(el) => (productRef.current["goodsAmt"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-11"></div>
                    <button
                      className="btn btn-success mx-2 my-4"
                      onClick={submitProduct}
                    >
                      +
                    </button>{" "}
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr className="tableheaderrowview">
                            <th>Sr No.</th>
                            <th>Product</th>
                            <th>Product Sub Type</th>
                            <th>Unit</th>
                            <th>Rate/Unit</th>
                            <th>Quantity Received</th>
                            <th>Amount Received </th>
                            <th>Current Quantity</th>
                            <th>Current Amount</th>

                            <th>Total Quantity</th>
                            <th>Total Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {productDetails.length > 0 ? (
                            productDetails.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.productName}</td>
                                <td>{item.productType}</td>
                                <td>{item.unit}</td>
                                <td>{item.pricePerUnit}</td>

                                <td>
                                  {editingRow === index ? (
                                    <input
                                      type="number"
                                      value={editData.quantity || ""}
                                      className="form-control"
                                      // onChange={(e) =>
                                      //   handleInputChange(
                                      //     "quantity",
                                      //     e.target.value
                                      //   )
                                      // }
                                    />
                                  ) : (
                                    item.quantity
                                  )}
                                </td>
                                <td>{item.value}</td>
                                <td>{item.currentQuantity}</td>

                                <td>{item.currentAmount}</td>

                                <td>{item.totalQuantity}</td>
                                <td>{item.value}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="11">No data present</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default HubStockInfoForm;
